import { Container, Stack } from '@mui/material';
import {
    MarkdownConverter,
    PoolFormattedRelativeTime,
    PoolTextButton,
    PoolTypography,
    useIsMobile,
} from '@synergy/components-next';
import { ReactElement, useEffect } from 'react';
import { SortingArrowLeftIcon } from '@synergy/theme-next';
import { useNavigate, useParams } from 'react-router';

import { ROUTES } from '../../../utils/routes';
import { fetchNewsDetail } from '../../../store/news-actions';
import { newsDetailSelector } from '../../../store/news-selectors';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

export const NewsPageDetail = (): ReactElement | null => {
    const newsDetail = useAppSelector(newsDetailSelector);

    const dispatch = useAppDispatch();
    const isMobile = useIsMobile();
    const { id: newsDetailId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (newsDetailId) {
            dispatch(fetchNewsDetail(+newsDetailId));
        }
    }, [dispatch, newsDetailId]);

    if (!newsDetail || (newsDetailId && newsDetail.id !== Number.parseInt(newsDetailId))) {
        return null;
    }

    return (
        <Container maxWidth="xl" sx={{ mt: { sm: 6, xs: 4 }, mb: { sm: 10, xs: 7.5 }, position: 'relative' }}>
            {!isMobile && (
                <PoolTextButton
                    startIcon={<SortingArrowLeftIcon />}
                    onClick={() => navigate(ROUTES.news.base)}
                    color="black"
                    sx={{ position: 'absolute', top: 10 }}
                >
                    <PoolTypography variant="button" translationId="app.common.back" />
                </PoolTextButton>
            )}

            <Stack gap={{ sm: 6, xs: 4 }} width={{ md: 700, sm: 620 }} margin={{ sm: 'auto' }}>
                <Stack gap={{ sm: 1, xs: 0.5 }}>
                    <PoolTypography variant="h3">{newsDetail.title}</PoolTypography>
                    <PoolTypography variant="body1" color="grey.800">
                        <PoolFormattedRelativeTime value={new Date(newsDetail.publishAt)} />
                    </PoolTypography>
                </Stack>
                {newsDetail.imageUrl && <img src={newsDetail.imageUrl} alt={newsDetail.title} width="100%" />}
                <MarkdownConverter value={newsDetail.text} />
            </Stack>
        </Container>
    );
};
